import { useState } from 'react'

import {
  EVENT_NAME_MOUSE_MOVE,
  EVENT_NAME_MOUSE_UP,
} from '../../../../constants/event'
import { stopPropagation } from '../../../../utils/events'
import { SCROLL_SLIDER_DRAG_THRESHOLD } from '../../ScrollSlider.constants'

export function useScrollSliderActions({ itemWidth, sliderRef }) {
  const [sliderGrabbing, setSliderGrabbing] = useState(false)

  function handleMouseDown(event) {
    const startPos = {
      left: sliderRef.current.scrollLeft,
      x: event.clientX,
    }

    function handleMouseMove(e) {
      const dx = e.clientX - startPos.x

      // Treat sub-threshold movement as click jitter, not a drag — otherwise
      // `handleSliderContentClick` would swallow normal clicks on children.
      if (Math.abs(dx) >= SCROLL_SLIDER_DRAG_THRESHOLD) {
        setSliderGrabbing(true)

        sliderRef.current.scrollLeft = startPos.left - dx
      }
    }

    function handleMouseUp() {
      setSliderGrabbing(false)

      document.removeEventListener(EVENT_NAME_MOUSE_MOVE, handleMouseMove)
      document.removeEventListener(EVENT_NAME_MOUSE_UP, handleMouseUp)
    }

    document.addEventListener(EVENT_NAME_MOUSE_MOVE, handleMouseMove)
    document.addEventListener(EVENT_NAME_MOUSE_UP, handleMouseUp)
  }

  // to prevent child click when grabbing
  function handleSliderContentClick(e) {
    if (sliderGrabbing) {
      stopPropagation(e)
    }
  }

  function handleClickSlide(item) {
    const itemRect = item.getBoundingClientRect()
    const sliderRect = sliderRef.current.getBoundingClientRect()

    // left side
    if (itemRect.x < sliderRect.x) {
      sliderRef.current.scrollTo(
        sliderRef.current.scrollLeft - (sliderRect.x - itemRect.x) - itemWidth,
        0
      )
      // right side
    } else if (itemRect.right > sliderRect.right) {
      sliderRef.current.scrollTo(
        sliderRef.current.scrollLeft +
          (itemRect.right - sliderRect.right) +
          itemWidth,
        0
      )
    }
  }

  return {
    handleClickSlide,
    handleMouseDown,
    handleSliderContentClick,
    sliderGrabbing,
  }
}
